var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{staticClass:"chart",style:({height: _vm.chartHeight + 'px'}),attrs:{"option":_vm.chartOptions,"autoresize":""}})}
var staticRenderFns = []

export { render, staticRenderFns }